<template>
  <div class="detail-dialog-left">
    <div class="detail-dialog-left__content">
      <!-- 无效跟进 && 类型是呼叫中心来源 -->
      <template v-if="activeStage.kind === 2 && activeStage.sourceType === 3">
        <Empty :empty-text="uselessTittle" />
      </template>
      <template v-else>
        <template v-if="opportunity.opportunityId && detailType === 'customer'">
          <div class="opportunity-block">
            <div class="label">商机拜访轨迹</div>
            <div class="value" @click="handleOpenDetail(opportunity)">
              {{ opportunity.opportunityName }}
            </div>
          </div>
        </template>
        <template v-if="['ykWechat', 'ykMobile'].includes(ykType)">
          <!-- 群聊 -->
          <template v-if="sourceType === 11">
            <div class="wx-friend-block">
              <div class="label">微信群聊</div>
              <div class="value">
                {{ wxParams.roomName || '' }}
              </div>
            </div>
          </template>
          <!-- 单聊 -->
          <template v-else-if="sourceType === 6">
            <div class="wx-friend-block">
              <div class="label">聊天好友</div>
              <div class="value">
                {{ wxParams.expandBusiness || '' }}
              </div>
            </div>
          </template>
        </template>
        <div class="followup-block">
          <div class="detail-dialog-left__title followup-title">
            <div class="prefix-line"></div>
            <span>跟进内容</span>
          </div>
          <div v-if="minutesId" class="top-desc">
            <span class="label">会议链接</span>
            <div class="meeting-url" @click="handleAiOneOpenUrl">
              <span>会议链接</span>
              <i class="icon-arrow-right-s-line t-iconfont"></i>
            </div>
          </div>
          <div v-else-if="url && !ykType" class="top-desc">
            <span class="label">会议链接</span>
            <div class="meeting-url" @click="handleOpenUrl(url)">
              <span>会议链接</span>
              <i class="icon-arrow-right-s-line t-iconfont"></i>
            </div>
          </div>
          <template v-if="isLiberalRules">
            <MarkdownView :show-string="communicateContents" />
          </template>
          <template v-else>
            <div class="content-box" v-html="showTextContent"></div>
          </template>
        </div>
        <div v-if="chatList.length && ykType !== 'ykWechat'" class="session-block">
          <div class="detail-dialog-left__title session-title">
            <div class="prefix-line"></div>
            <span>会话原文</span>
          </div>
          <AiDetailTalk
            ref="aiDetailTalkRef"
            :chat-list="chatList"
            @startWithTime="handleStartWithTime"
          ></AiDetailTalk>
        </div>
        <div v-if="ykType === 'ykWechat'" class="wechat-session-block">
          <div class="detail-dialog-left__title" style="margin-bottom: 0">
            <div class="prefix-line"></div>
            <!-- <span>聊天记录</span> -->
            <span>{{ sourceType === 11 ? '微信群聊' : '微信单聊' }}</span>
          </div>
          <div
            v-if="ykMessageParams.wechatId || ykMessageParams.roomId"
            class="wechat-session-block__content"
          >
            <YkMessageDetail
              ref="refYkMessageDetail"
              class="wechat-session-block__message"
              :extra-params="ykMessageExtraParams"
              :params="ykMessageParams"
              :source="props.sourceType === 11 ? 'group' : 'person'"
              :title="ykMessageTitle"
            />
          </div>
        </div>
      </template>

      <!-- 企微-会话存档组件唤起-当企微环境且有该参数就渲染 -->
      <div v-if="sessionArchiveParams.sessionUserId" class="session-archive-block">
        <div class="detail-dialog-left__title session-archive-title">
          <div class="prefix-line"></div>
          <span>会话聊天记录</span>
        </div>
        <div class="session-archive-block__friendship">
          <template v-if="sessionArchiveParams.chatId">
            <span class="label">企微群聊名称</span>
            <span class="value">{{ sessionArchiveParams.chatName }}</span>
          </template>
          <template v-else-if="sessionArchiveParams.externalUserId">
            <span class="label">聊天好友</span>
            <span class="value">{{ sessionArchiveParams.remark }}</span>
          </template>
        </div>
        <el-button @click="toOpenSessionDetail">查看聊天记录</el-button>
      </div>
    </div>

    <div v-if="isAudio" class="audio-block">
      <AudioPlayer ref="audioPlayerRef" :audio-url="url" is-pc-detail :show-download="true" />
    </div>

    <AiDetailDialog
      v-if="showDetail"
      v-model:show-detail="showDetail"
      :deatil-data="deatilData"
      detail-type="opportunity"
    ></AiDetailDialog>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import AiDetailTalk from '@/pages/ai-board/components/components/ai-detail-talk.vue'
import AudioPlayer from '@/components/audio-player.vue'
import AiDetailDialog from '@/pages/ai-board/components/components/ai-detail-dialog/index.vue'
import MarkdownView from '@/components/markdown-view/index.vue'
import Empty from '@/components/Empty/index.vue'
import YkMessageDetail from './components/yk-message/yk-message-detail/index.vue'

import xbbSdk from 'xbb-sdk'

const props = defineProps({
  meetingDuration: {
    type: String,
    default: ''
  },
  chatList: {
    type: Array,
    default: () => []
  },
  url: {
    // 音频播放URL
    type: String,
    default: ''
  },
  communicateContents: {
    type: String,
    default: ''
  },
  uselessTittle: {
    type: String,
    default: ''
  },
  isLiberalRules: {
    type: Number,
    default: 0
  },
  opportunity: {
    type: Object,
    default: () => ({})
  },
  detailType: {
    type: String,
    default: 'customer'
  },
  behavingId: {
    type: String,
    default: ''
  },
  activeStage: {
    type: Object,
    default: () => ({})
  },
  sessionArchiveParams: {
    type: Object,
    default: () => ({})
  },
  minutesId: {
    type: String,
    default: ''
  },
  ykType: {
    type: String,
    default: ''
  },
  sourceType: {
    type: Number,
    default: undefined
  },
  wxParams: {
    type: Object,
    default: () => ({})
  },
  ykWechatConfig: {
    type: Object,
    default: () => ({})
  }
})

const emits = defineEmits(['openUrl'])

const handleOpenUrl = (url) => {
  emits('openUrl', url)
}

const handleAiOneOpenUrl = () => {
  window.open(`https://shanji.dingtalk.com/app/transcribes/${props.minutesId}`, '_blank')
}

const isAudio = computed(() => {
  // audioUrl.value 链接是否是音频文件
  const audioExtensions = ['mp3', 'wav', 'ogg', 'flac', 'aac', 'm4a']
  const url = props.url
  if (!url) return false
  const ext = url.split('.').pop().toLowerCase()
  return audioExtensions.includes(ext)
})

const showTextContent = computed(() => {
  // \n 替换为 <br>
  const replacedText = props.communicateContents
    .replace(/\*\*(.*?)\*\*/g, '<span style="font-weight: bold;color: #323233;">$1</span>')
    .replace(/\n/g, '<br>')
  return replacedText
})

const ykMessageParams = computed(() => ({
  loginUserId: props.wxParams.loginUserId || '',
  roomId: props.ykWechatConfig.roomId || '',
  wechatId: props.ykWechatConfig.wechatId || '',
  wechatUserId: props.ykWechatConfig.wechatUserId || ''
}))

const ykMessageExtraParams = computed(() => {
  const timer = new Date(props.activeStage.time).getTime()
  const timeRange = [timer, timer]
  return {
    timeRange
  }
})

const ykMessageTitle = computed(() => ({
  name: props.wxParams.expandBusiness || props.wxParams.name || '',
  roomName: props.wxParams.roomName || ''
}))

const showDetail = ref(false)
const deatilData = ref({})

const audioPlayerRef = ref(null)
const aiDetailTalkRef = ref(null)

const handleOpenDetail = (item) => {
  deatilData.value = {
    id: props.behavingId,
    appId: props.opportunity.appId,
    opportunityId: props.opportunity.opportunityId
  }
  showDetail.value = true
}

const handleStartWithTime = (time) => {
  if (isAudio.value) {
    audioPlayerRef.value.handleStartWithTime(time)
  }
}

const refYkMessageDetail = ref(null)
const handleClickTime = (seconds, item) => {
  // 如果是云客手机
  if (['ykWechat', 'ykMobile'].includes(props.ykType)) {
    console.log('🚀 ~ handleClickTime ~ seconds:', seconds, item)
    refYkMessageDetail.value.locationTargetMessage({
      messageItem: item,
      timeRange: [seconds, seconds]
    })
    return
  }
  handleStartWithTime(seconds)
  aiDetailTalkRef.value?.handleScrollToTime(seconds)
}

// 唤起外部会话组件
const toOpenSessionDetail = () => {
  xbbSdk.sendMessage('openSessionDetailDialog', { ...props.sessionArchiveParams })
}

defineExpose({
  handleClickTime
})
</script>

<style lang="scss" scoped>
.detail-dialog-left {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .detail-dialog-left__content {
    flex: 1;
    overflow: auto;
    position: relative;
    display: flex;
    flex-direction: column;

    .opportunity-block {
      display: flex;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 16px;

      .label {
        margin-right: 12px;
        color: #646566;
      }

      .value {
        color: #248df5;
        cursor: pointer;
      }
    }

    .wx-friend-block {
      display: flex;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 16px;

      .label {
        margin-right: 12px;
        color: #646566;
      }

      .value {
        color: #323233;
      }
    }

    .followup-block {
      .top-desc {
        display: flex;
        margin-bottom: 8px;
        font-size: 14px;
        line-height: 20px;

        .label {
          flex: 0 0 84px;
          margin-right: 12px;
          color: #646566;
        }

        .meeting-duration {
          color: #323233;
        }

        .meeting-url {
          display: flex;
          color: #248df5;
          cursor: pointer;

          i {
            margin-left: 4px;
            font-size: 16px;
          }
        }
      }

      .content-box {
        padding: 8px;
        line-height: 21px;
      }
    }

    .wechat-session-block {
      display: flex;
      flex: 1;
      flex-direction: column;

      &__content {
        height: 590px;
        margin-top: 16px;
        overflow: hidden;
        border: 1px solid #e5e6eb;
        border-radius: 12px;
      }

      &__message {
        height: 100%;
      }
    }

    .detail-dialog-left__title {
      margin-bottom: 16px;
      display: flex;
      align-items: center;

      span {
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        color: #323233;
      }

      .prefix-line {
        width: 4px;
        height: 12px;
        border-radius: 12px;
        background: #7a52f4;
        margin-right: 8px;
      }
    }

    .session-archive-block {
      &__friendship {
        margin-bottom: 12px;

        .label {
          margin-right: 12px;
          color: #646566;
        }

        .value {
          color: #323233;
        }
      }
    }
  }

  .audio-block {
    flex: 0 0 auto;
    height: 48px;
    margin-top: 16px;
  }
}
</style>
